import { RefObject, useEffect } from "react";

/** Açılır panelleri dışarı tıklama ve Escape ile kapatır. */
export function useDismissable(
  ref: RefObject<HTMLElement>,
  isOpen: boolean,
  onClose: () => void,
  /** Portal'a taşınan panel köke göre "dışarıda" kalır; o da içeri sayılır. */
  extraRef?: RefObject<HTMLElement>
): void {
  useEffect(() => {
    if (!isOpen) return;

    const onPointerDown = (event: MouseEvent | TouchEvent) => {
      const node = ref.current;
      const extra = extraRef?.current;
      if (extra && extra.contains(event.target as Node)) return;
      if (node && !node.contains(event.target as Node)) onClose();
    };

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("touchstart", onPointerDown);
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("touchstart", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [ref, isOpen, onClose, extraRef]);
}
